import http from '../../services/http/index';
import forResponse from '../../utils/forResponse';
import { COUNTRIES_URL } from '../../constants/apiUrls/apiUrls';


export const getCountries = () => forResponse(http.get(COUNTRIES_URL));
